import { FeedbackRepliesThread, FeedbackRequest, UpdateFeedbackParams } from "../../types/feedback/feedback.model";
import { api } from "../axios";

const CREATE_FEEDBACK_URL = import.meta.env.VITE_CREATE_FEEDBACK_URL;
const GET_FEEDBACKS_BY_USER_ID_URL = import.meta.env.VITE_GET_FEEDBACKS_BY_USER_ID_URL;


export const createFeedbackApi = async (data: FeedbackRequest) => {
    try {
        const res = await api.post(CREATE_FEEDBACK_URL, data);
        return res.data;
    } catch (error) {
        console.log("createFeedback in feedbacksApi error: ", error);
        throw error;
    }
};


export const getProfileFeedbacksByUserId = async (userId: number) => {
    try {
        const profileFeedbacks = await api.get(GET_FEEDBACKS_BY_USER_ID_URL + userId);
        return profileFeedbacks.data;
    } catch (error) {
        console.log("getProfileFeedbacksByUserId in feedbacksApi error: ", error);
        throw error;
    }
};

export const deleteFeedbackById = async (feedbackId: number) => {
    try {
        // ссылка у createFeedbackUrl такая же как у deleteFeedbackById. Заканчивается на /feedbacks/, нужно добавить id отзыва и слэш в конце
        await api.delete(`${CREATE_FEEDBACK_URL}/${feedbackId}`);
    } catch (error) {
        console.log("deleteFeedbackById in feedbacksApi error: ", error);
        throw error;
    }
}

export const updateFeedbackApi = async ({ feedbackId, user_id, rating, description }: UpdateFeedbackParams) => {
    try {
        // ссылка у createFeedbackUrl такая же как у deleteFeedbackById. Заканчивается на /feedbacks/, нужно добавить id отзыва и слэш в конце
        await api.patch(`${CREATE_FEEDBACK_URL}/${feedbackId}`, { user_id, rating, description });
    } catch (error) {
        console.log("updateFeedbackApi in feedbacksApi error: ", error);
        throw error;
    }
}

export const getFeedbackRepliesByFeedbackId = async (feedbackId: number): Promise<FeedbackRepliesThread> => {
    try {
        const res = await api.get(`/api/feedbacks/${feedbackId}/replies`);
        return res.data;
    } catch (error) {
        console.log("getFeedbackRepliesByFeedbackId in feedbacksApi error: ", error);
        throw error;
    }
}

export const createFeedbackReplyApi = async (feedbackId: number, content: string) => {
    try {
        const res = await api.post(`/api/feedbacks/${feedbackId}/replies`, { content });
        return res.data;
    } catch (error) {
        console.log("createFeedbackReplyApi in feedbacksApi error: ", error);
        throw error;
    }
}

export const updateFeedbackReplyApi = async (replyId: number, content: string) => {
    try {
        const res = await api.patch(`/api/feedbacks/replies/${replyId}`, { content });
        return res.data;
    } catch (error) {
        console.log("updateFeedbackReplyApi in feedbacksApi error: ", error);
        throw error;
    }
}

export const deleteFeedbackReplyApi = async (replyId: number) => {
    try {
        await api.delete(`/api/feedbacks/replies/${replyId}`);
    } catch (error) {
        console.log("deleteFeedbackReplyApi in feedbacksApi error: ", error);
        throw error;
    }
}